import type { ContactUsConfig } from './types'
import { commonTexts } from './common'
import { theme as brandTheme } from '@/config/brands'

export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: brandTheme.bgGlobal,
    bgTertiary: brandTheme.bgTag,
    textPrimary: brandTheme.textPrimary,
    textTertiary: brandTheme.textTertiary,
    textPlaceholder: brandTheme.textTertiary,
    accentRed: brandTheme.primaryColor,
    primaryColor: brandTheme.primaryColor,
    whiteColor: brandTheme.textInverse,
  },
}
